var map = {
	"./de/general13/slide3.svg": 869775,
	"./en/general13/slide3.svg": 574995,
	"./es/general13/slide3.svg": 271132,
	"./fr/general13/slide3.svg": 19780,
	"./nl/general13/slide3.svg": 16746,
	"./pt/general13/slide3.svg": 382968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110651;